import React from 'react';
import { XCloseIcon } from '@rsos/assets/icons';
import { Box, Text } from '@rsos/components/capstone/base';
import { ACCEPTED } from '@rsos/constants/alertStatuses';
import { ACTIVE_ASSAILANT } from '@rsos/constants/alertTypes';
import { CloseButton } from './DataCards.styles';
import ShareIncidentButton from './ShareIncident/ShareIncidentButton';
import { getAlertHeaderText } from './utils';

const DataCardHeader = React.forwardRef(
  (
    {
      onClose,
      emergencyType,
      siteType,
      serviceProviderName,
      alertStatus,
      setIsShareIncidentModalOpen,
      isShareIncidentAvailable,
    },
    ref,
  ) => {
    const headerColor =
      emergencyType?.name === ACTIVE_ASSAILANT && alertStatus !== ACCEPTED
        ? 'lightDanger'
        : 'states';
    return (
      <Box
        horizontal
        justify="space-between"
        pb={2}
        data-name="alert-data-card-header"
        ref={ref}
      >
        <Box>
          <Text color={headerColor} fontWeight="bold" size="normal">
            {getAlertHeaderText(emergencyType, siteType)}
          </Text>
          <Text color="secondaryText" size="small">
            Source: {serviceProviderName}
          </Text>
        </Box>
        <Box horizontal align="center" height="20px">
          {isShareIncidentAvailable && (
            <ShareIncidentButton
              setIsShareIncidentModalOpen={setIsShareIncidentModalOpen}
            />
          )}
          <CloseButton onClick={() => onClose()}>
            <XCloseIcon />
          </CloseButton>
        </Box>
      </Box>
    );
  },
);

export default DataCardHeader;
